module.exports = __webpack_public_path__ + "img/section_icon_2.e520ff45.svg";